import router from "@/router";
import { Module } from "vuex";
import { RootState } from "@/store";

export interface AuthModuleState {
  user: User | null;
}

export const AuthModule: Module<AuthModuleState, RootState> = {
  namespaced: true,
  state: { user: null },
  mutations: {
    user: (state: any, payload: any) => {
      state.user = payload;
    },
    reset: (state: any) => {
      state.user = null;
      localStorage.removeItem("access-token");
      router.push("/");
    }
  }
};
